import { useCallback } from "react";
import type { YouTubePlayer } from "youtube-player/dist/types";

import { useIntersection } from "scmp-app/lib/hooks";

type Parameters = {
  adsManager?: google.ima.AdsManager;
  isAdPlaying: boolean;
  isAdStarted: boolean;
  player?: YouTubePlayer;
};

export const useIntersectionHandler = (parameters: Parameters) => {
  const { adsManager, isAdPlaying, isAdStarted, player } = parameters;

  const { captureIntersectionElement, intersection } = useIntersection({
    threshold: 0.5,
  });

  const handleIsIntersecting = useCallback(async () => {
    try {
      if (isAdStarted) {
        await player?.pauseVideo();
        adsManager?.resume();
        return;
      }
      await player?.playVideo();
    } catch (error) {
      console.error("handleIsIntersecting playVideo", error);
    }
  }, [adsManager, isAdStarted, player]);

  const handleIsNotIntersecting = useCallback(async () => {
    try {
      if (isAdPlaying) adsManager?.pause();
      await player?.pauseVideo();
    } catch (error) {
      console.error("handleIsNotIntersecting pauseVideo", error);
    }
  }, [adsManager, isAdPlaying, player]);

  return {
    captureIntersectionElement,
    handleIsIntersecting,
    handleIsNotIntersecting,
    intersection,
  };
};
